import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const healthCheck = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
